import { ArrowLeft } from 'react-bootstrap-icons';
import { useNavigate } from 'react-router-dom';

const BackButton = ({ label = 'Volver' }) => {
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate(-1)}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '8px 16px',
        backgroundColor: 'transparent',
        color: '#fff',
        border: '1px solid #fff',
        borderRadius: '8px',
        cursor: 'pointer',
      }}
    >
      <ArrowLeft size={18} />
      {label}
    </button>
  );
};

export default BackButton;
